import {Col, media, Row, Spacer} from '@nfq/react-grid';
import {useTranslation} from 'next-i18next';
import styled from 'styled-components';

import {EquipmentGrid} from 'UI/components/content/ultra/EquipmentGrid';
import {OutfitGrid} from 'UI/components/content/ultra/OutfitGrid';
import {Accordion} from 'UI/components/layout/ultra/Accordion';
import {Eyebrow} from 'UI/components/layout/ultra/Eyebrow';
import {Headline} from 'UI/components/layout/ultra/Headline';
import {HGroup} from 'UI/components/layout/ultra/HGroup';
import {Text} from 'UI/components/layout/ultra/Text';

/**
 * React component for displaying the equipment section.
 * This component renders a section containing information about equipment and outfit.
 *
 * @returns JSX element representing the equipment section.
 *
 * @example
 * ```tsx
 * <EquipmentSection />
 * ```
 */
export const EquipmentSection = () => {
    const {t} = useTranslation('ultra', {keyPrefix: 'details.equipment'});

    return (
        <Row justify="center">
            <Col lg={10} xs={12}>
                <HGroup align="center">
                    <Eyebrow>{t('eyebrow')}</Eyebrow>
                    <Headline>{t('headline')}</Headline>
                </HGroup>
                <Spacer y={{lg: 40, xs: 12}} isNotStretching />
                <Accordion title={t('outfit.headline')}>
                    <DescriptionWrapper>
                        <Text>{t('outfit.description')}</Text>
                    </DescriptionWrapper>
                    <Spacer y={{lg: 12, xs: 6}} />
                    <OutfitGrid />
                </Accordion>
                <Spacer y={{lg: 20, xs: 10}} isNotStretching />
                <Accordion title={t('equipment.headline')}>
                    <DescriptionWrapper>
                        <Text>{t('equipment.description')}</Text>
                    </DescriptionWrapper>
                    <Spacer y={{lg: 12, xs: 6}} />
                    <EquipmentGrid />
                </Accordion>
            </Col>
        </Row>
    );
};

const DescriptionWrapper = styled.div`
    width: 100%;

    ${media('lg')} {
        width: 60%;
    }
`;